export namespace Permissions {
  export enum Type {
    CREATE_APPLICATIONS = "Create Applications",
    SEARCH_APPLICATIONS = "Search Applications",
    VIEW_APPLICATION_LIST = "View Application List",
    VIEW_APPLICATION = "View Application",
    VIEW_EMPLOYEE_APPLICATION = "View Employee Application",
    VIEW_APPLICATION_UNMASKED = "View Application Unmasked",
    VIEW_EMPLOYEE_ALL_PRODUCTS_APPLICATION = "View Employee All Type Of Applications",
    VIEW_GLOBAL_SETTING = "View Global Setting",
    ADD_GLOBAL_SETTING = "Add New Global Setting",
    EDIT_GLOBAL_SETTING = "Edit Global Setting",
    DELETE_GLOBAL_SETTING = "Delete Global Setting",
    VIEW_BRAND = "View Brand",
    ADD_NEW_BRAND = "Add New Brand",
    EDIT_BRAND = "Edit Brand",
    DELETE_BRAND = "Delete Brand",
    VIEW_PRODUCT = "View Product",
    ADD_NEW_PRODUCT = "Add New Product",
    EDIT_PRODUCT = "Edit Product",
    DELETE_PRODUCT = "Delete Product",
    VIEW_AUDIT_LOGS = "View Audit Logs",
    VIEW_AUDIT_LOGS_UNMASKED = "View Audit Logs Unmasked",
    VIEW_REPORT_LINKS = "View Report Links",
    CREATE_MAINTENANCE_BANNER = "Create Maintenance Banner",
    TOGGLE_MAINTENANCE_BANNER = "Toggle Maintenance Banner",
    VIEW_LOGS = "View Logs",
    RESUBMIT_APPLICATION = "Re-Submit Application",
    EXPORT = "Export Applications",
    MODIFY_APPLICATION_STATE = "Modify Application State",
    TCB_MOVING_STATE_APPLICATION = "TCB Consumer: Moving state of application",
    BASK_MOVING_STATE_APPLICATION = "Bask: Moving state of application",
    PWA_MOVING_STATE_APPLICATION = "PWA: Moving state of application",
    RESUBMIT_KYC = "Re-submit KYC",
    VIEW_CONFIGURATION = "View Configuration",
    TCB_CONSUMER_RESUBMIT_APP = "TCB Consumer: Re-submit application (Push to Core)",
    TCB_Consumer_Execute_KYC = "TCB Consumer: Execute KYC, Request ID, Execute ID Verification",
    TCB_Consumer_RESUME_APP = "TCB Consumer: Resume Application",
    BASK_CONSUMER_RESUBMIT_APP = "Bask: Re-submit application (Push to Core)",
    BASK_Consumer_Execute_KYC = "Bask: Execute KYC, Request ID, Execute ID Verification",
    BASK_Consumer_RESUME_APP = "Bask: Resume Application",
    PWA_CONSUMER_RESUBMIT_APP = "PWA: Re-submit application (Push to Core)",
    PWA_Consumer_Execute_KYC = "PWA: Execute KYC, Request ID, Execute ID Verification",
    PWA_CONSUMER_RESUME_APP = "PWA: Resume Application",
    NAO_CREATE_APPLICATION = "NAO: Create application",
    NAO_CUSTOMER_SEARCH = "NAO: Customer search",
    VIEW_SESSION_REPLAY = "View Session Replay",
    VIEW_CAMPAIGN_PROMOTION = "View Campaign/Promotion",
    ADD_CAMPAIGN_PROMOTION = "Add Campaign/Promotion",
    EDIT_CAMPAIGN_PROMOTION = "Edit Campaign/Promotion"
  }
}
